import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;
const id = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const creatorId = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const firmId =
  JSON.parse(localStorage.getItem("authUser"))?.response?.adminId ||
  JSON.parse(localStorage.getItem("authUser"))?.response?.firmId;
const Role = JSON.parse(localStorage.getItem("authUser"))?.response?.role;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);
// API FUNCTIONS BELOW 👇🏻

// 🔥 CREATE DESIGNATION
export const createDesignationApi = async (data) => {
  try {
    const res = await axiosInstance.post("/designation/create", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET DESIGNATIONS BY DEPARTMENT
export const getDesignationsByDepartmentApi = async (departmentId) => {
  try {
    const res = await axiosInstance.get(
      `/designation/by-department/${departmentId}`
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 DELETE DESIGNATION (SOFT DELETE)
export const deleteDesignationApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/designation/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 REACTIVATE DESIGNATION
export const reactivateDesignationApi = async (id) => {
  try {
    const res = await axiosInstance.put(`/designation/reactivate/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 UPDATE DESIGNATION
export const updateDesignationApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/designation/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET INACTIVE DESIGNATIONS (if backend adds later)
export const getInactiveDesignationsApi = async () => {
  try {
    const res = await axiosInstance.get(`/designation/inactive`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
// grouped listing
export const getGroupedDesignationsApi = async (params={}) => {
  try {
    const res = await axiosInstance.get("/designation/grouped/list",{ params });
    return res.data;
  } catch (error) {
    throw error;
  }
};
export default axiosInstance;